import { render, staticRenderFns } from "./manual.vue?vue&type=template&id=033f0047&scoped=true"
import script from "./manual.vue?vue&type=script&lang=js"
export * from "./manual.vue?vue&type=script&lang=js"
import style0 from "./manual.vue?vue&type=style&index=0&id=033f0047&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "033f0047",
  null
  
)

export default component.exports